const apiDomain = process.env.REACT_APP_API_DOMAIN
const apiVersion = process.env.REACT_APP_API_VERSION
const apiUrlMut = `${apiDomain}/${apiVersion}/`

const apiDomainCar = process.env.REACT_APP_API_DOMAIN_CAR
const apiUrlCar = `${apiDomainCar}/${apiVersion}/`

const apiDomainInvoice = process.env.REACT_APP_API_DOMAIN_INVOICE
export const apiUrlInvoice = `${apiDomainInvoice}/`

export const loginClientId = process.env.REACT_APP_LOGIN_CLIENT_ID
export const reponseType = process.env.REACT_APP_LOGIN_RESPONSE_TYPE
export const scopes = process.env.REACT_APP_LOGIN_SCOPES
export const autorityUrl = process.env.REACT_APP_LOGIN_AUTHORITY_URL
export const postLoginRedirectUrl = process.env.REACT_APP_LOGIN_REDIRECT_URL
export const silentRedirectUri = process.env.REACT_APP_LOGIN_SILENT_RENEW_URI
export const metadataUrl = process.env.REACT_APP_LOGIN_METADATA_URL
export const logoutUrl = process.env.REACT_APP_LOGOUT_URL
export const logoutRedirectUrl = process.env.REACT_APP_LOGOUT_REDIRECT_URL

export const OidcLogLevel = process.env.REACT_APP_OIDC_LOG_LEVEL

export const clientConnectBaseUrl = process.env.REACT_APP_CLIENT_CONNECT_BASE_URL
export const clientConnectRedirectUrl = process.env.REACT_APP_CLIENT_CONNECT_REDIRECT_URL
export const grdfClientId = process.env.REACT_APP_GRDF_CLIENT_ID
export const clientConnectState = process.env.REACT_APP_CLIENT_CONNECT_STATE
export const clientConnectNomTiers = process.env.REACT_APP_CLIENT_CONNECT_NOM_TIERS

const apiDomainEmcm = process.env.REACT_APP_API_DOMAIN_EMCM
const apiVersionEmcm = process.env.REACT_APP_API_VERSION_EMCM
export const apiUrlEmcm = `${apiDomainEmcm}/${apiVersionEmcm}/`

export const requiredRoles = ['superuser', 'read:eview', 'admin:eview', 'sites:eview']
export const basicRoles = ['superuser', 'read:eview', 'admin:eview']
export const otherRoles = ['superuser', 'sites:eview']

export const apiUrl = (platform = 'MUT') => {
  switch (platform) {
    case 'NONE':
      return ''
    case 'INVOICE':
      return apiUrlInvoice
    case 'CAR':
      return apiUrlCar
    case 'MUT':
    default:
      return apiUrlMut
  }
}
